/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.trello.integration.InstallRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */
export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */
export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */
export type ChirpVoid = {};

export type HubSpotOwnedIntegration =
  | 'DEV_HUB_TEST_APP'
  | 'EVENTBRITE'
  | 'GOOGLE_CALENDAR'
  | 'GO_TO_WEBINAR'
  | 'SURVEY_MONKEY'
  | 'UBER_CONFERENCE'
  | 'WISTIA'
  | 'SALESFORCE'
  | 'LINKEDIN_SALES_NAVIGATOR'
  | 'SHOPIFY'
  | 'SLACK'
  | 'GOOGLE_SEARCH_CONSOLE'
  | 'ZOOM'
  | 'GOOGLE_SHEETS'
  | 'VIDYARD'
  | 'OFFICE_365_CALENDAR'
  | 'QUICK_BOOKS_ONLINE'
  | 'MAILCHIMP'
  | 'MICROSOFT_DYNAMICS_365'
  | 'DATA_AUDITOR_DYNAMICS_365'
  | 'NETSUITE'
  | 'JIRA'
  | 'MSTEAMS'
  | 'GOOGLE_MEET'
  | 'DOCUSIGN'
  | 'AIRTABLE'
  | 'TRELLO'
  | 'ONE_SIGNAL'
  | 'ZOHO'
  | 'PIPEDRIVE'
  | 'COPPER'
  | 'ZOOM_APPS'
  | 'ACTIVE_CAMPAIGN'
  | 'KEAP'
  | 'GOOGLE_CONTACTS'
  | 'DATASYNC'
  | 'GOOGLE_CHAT'
  | 'GOOGLE_DRIVE'
  | unhandledEnumCase;

export type IntegrationInstallUser = {
  hubSpotOwnedIntegration: HubSpotOwnedIntegration;
  username?: string;
  email?: string;
  accountId?: string;
  accountName?: string;
  installTime?: number;
};

export type InstallationRequest = { accessToken: string };

export type GetInstallUserResponse = { results: IntegrationInstallUser };

export type InstallIntegrationRequestType = Requestify<InstallationRequest>;
export type InstallIntegrationResponseType = ChirpVoid;
export type InstallIntegrationErrorType = EmptyError & HubspotMetadata;
export const installIntegrationRpc: ChirpAvroRpcDetails<
  InstallIntegrationRequestType,
  InstallIntegrationResponseType,
  InstallIntegrationErrorType,
  false
> = {
  serviceName: 'com.hubspot.trello.integration.InstallRpc',
  rpcName: 'installIntegration',
  auth: 'app',
  fingerprint: 'ervywsDgp0qOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetInstallUserResponseType = GetInstallUserResponse;
export type GetInstallUserErrorType = EmptyError & HubspotMetadata;
export const getInstallUserRpc: ChirpAvroRpcDetails<
  undefined,
  GetInstallUserResponseType,
  GetInstallUserErrorType,
  false
> = {
  serviceName: 'com.hubspot.trello.integration.InstallRpc',
  rpcName: 'getInstallUser',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAL4wmdotcOaJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UninstallIntegrationResponseType = ChirpVoid;
export type UninstallIntegrationErrorType = EmptyError & HubspotMetadata;
export const uninstallIntegrationRpc: ChirpAvroRpcDetails<
  undefined,
  UninstallIntegrationResponseType,
  UninstallIntegrationErrorType,
  false
> = {
  serviceName: 'com.hubspot.trello.integration.InstallRpc',
  rpcName: 'uninstallIntegration',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
